var hooxSliderPress = document.querySelector(".hoox-press__slider");
var hooxSliderPressLength = document.querySelectorAll(".hoox-press__items").length;

if (hooxSliderPress) {
  var slider = new Swiper(hooxSliderPress, {
    slidesPerView: 1,
    loop: true,
    breakpoints: {
      767: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 28,
        watchOverflow: true,
        loop: false,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
